(()=>{
const root=document.querySelector('.sh[data-audience="small-homes-and-apartments"]');
if(!root)return;
const $=selector=>root.querySelector(selector);
const local=['127.0.0.1','localhost'].includes(location.hostname);
const origin=local?'https://speediance.eu':location.origin;
const rootPath=window.Shopify?.routes?.root||'/';

/* Feature tabs */
const features={
 guided:{image:'guided',title:'A clear place to start.',body:'See exercise demonstrations and follow an on-screen workout, or build your own routine. No dedicated gym room needed to get moving.',note:'23.8-inch touchscreen. Every movement demonstrated before you start.',alt:'Gym Monster 3 touchscreen showing the guided workout library'},
 weights:{image:'weights',title:'Change the weight. Skip the plates.',body:'Adjust digital resistance on the screen between sets, in 1 kg steps. No plates to load, unload or store.',note:'Gym Monster 3 provides up to 100 kg of digital resistance, adjustable in 1 kg steps.',alt:'Gym Monster 3 digital resistance rail with weight markings'},
 fold:{image:'fold',title:'A workout space. A living space.',body:'Lower the platform for training. Fold it away when you finish, and the room is a room again.',note:'0.26 m² folded storage footprint.',alt:'Gym Monster 3 folded flat for storage'}
};
const manifest=$('#sh-feature-assets');const assets=manifest?JSON.parse(manifest.textContent):null;
const asset=(name,size)=>assets?assets[name][size]:null;
const tabs=Array.from(root.querySelectorAll('[data-feature]'));
function choose(tab,focus=false){
 const f=features[tab.dataset.feature];
 tabs.forEach(t=>{t.setAttribute('aria-selected',String(t===tab));t.tabIndex=t===tab?0:-1;});
 $('#sh-feature-panel').setAttribute('aria-labelledby',tab.id);
 const img=$('#sh-feature-image');
 img.src=asset(f.image,'1680');img.srcset=`${asset(f.image,'840')} 840w, ${asset(f.image,'1680')} 1680w`;img.alt=f.alt;
 $('#sh-feature-title').textContent=f.title;$('#sh-feature-body').textContent=f.body;$('#sh-feature-note').textContent=f.note;
 $('.sh-feature-number').textContent=`0${tabs.indexOf(tab)+1} / 03`;
 if(focus)tab.focus();
}
tabs.forEach((tab,i)=>{
 tab.addEventListener('click',()=>choose(tab));
 tab.addEventListener('keydown',event=>{const next={ArrowRight:(i+1)%tabs.length,ArrowLeft:(i+tabs.length-1)%tabs.length,Home:0,End:tabs.length-1}[event.key];if(next!==undefined){event.preventDefault();choose(tabs[next],true);}});
});

/* Sticky mobile bar */
const sticky=$('.sh-mobile-action');const visible=new Map();
if('IntersectionObserver' in window){
 const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>visible.set(entry.target,entry.isIntersecting));sticky.hidden=[...visible.values()].some(Boolean);},{threshold:.05});
 [$('.sh-hero'),$('#sh-setup'),$('#sh-demo'),$('.sh-close')].forEach(section=>section&&observer.observe(section));
}

/* Live product data: GM3, Ultra, Nano */
const money=(amount,currency)=>new Intl.NumberFormat(document.documentElement.lang||'en-AU',{style:'currency',currency,currencyDisplay:'narrowSymbol',minimumFractionDigits:0,maximumFractionDigits:0}).format(amount/100);

function fetchProduct(handle,apiPath){
 const abort=new AbortController();const timer=setTimeout(()=>abort.abort(),8000);
 return fetch(local?apiPath:`${rootPath}products/${handle}.js`,{signal:abort.signal}).then(r=>{if(!r.ok)throw new Error('unavailable');return r.json();}).finally(()=>clearTimeout(timer));
}

let gm3Studio=null,ultra=null,nano=null;

fetchProduct('speediance-gym-monster-3','/api/product/gm3').then(product=>{
 const variant=(product.variants||[]).find(v=>v.available&&Number(v.price)>0&&(v.public_title||v.title||'').trim().toLowerCase()==='gym monster 3 / studio');
 if(!variant)return;
 const currency=product.currency||window.Shopify?.currency?.active;
 if(!currency)return;
 gm3Studio={variant,currency,url:origin+rootPath+`products/speediance-gym-monster-3?variant=${encodeURIComponent(variant.id)}`};
 const price=Number(variant.price),compareAt=Number(variant.compare_at_price||0);
 const hasSaving=compareAt>price;const save=hasSaving?compareAt-price:0;
 const priceText=money(price,currency);

 $('#sh-price').textContent=priceText;
 if(hasSaving){const c=$('#sh-price-compare');c.textContent=money(compareAt,currency);c.hidden=false;const s=$('#sh-price-save');s.textContent=`Save ${money(save,currency)}`;s.hidden=false;}
 const ctaText=hasSaving?`Get Studio, save ${money(save,currency)}`:'Explore Gym Monster 3 Studio';
 const heroCta=$('#sh-hero-cta');heroCta.textContent=ctaText;heroCta.href=gm3Studio.url;
 const productLink=$('#sh-product-link');productLink.href=gm3Studio.url;productLink.innerHTML=`${hasSaving?`Get Studio for ${priceText}`:'Explore the Studio package'} <span aria-hidden="true">→</span>`;
 const closeCta=$('#sh-close-cta');closeCta.textContent=hasSaving?`Claim the ${money(save,currency)} saving`:ctaText;closeCta.href=gm3Studio.url;
 const stickyCta=$('#sh-sticky-cta');if(stickyCta){stickyCta.innerHTML=`${hasSaving?`Save ${money(save,currency)} on Gym Monster 3 Studio`:'Explore Gym Monster 3 Studio'} <span aria-hidden="true">→</span>`;stickyCta.href=gm3Studio.url;}
 if(variant.featured_image&&variant.featured_image.src){const productImg=$('#sh-product-image');if(productImg)productImg.src=variant.featured_image.src;}
 renderFit();
}).catch(()=>{});

fetchProduct('speediance-gym-monster-ultra','/api/product/ultra').then(product=>{
 const variant=(product.variants||[]).find(v=>v.available);if(!variant)return;
 const currency=product.currency||window.Shopify?.currency?.active;if(!currency)return;
 ultra={variant,currency,url:origin+rootPath+`products/speediance-gym-monster-ultra?variant=${encodeURIComponent(variant.id)}`};
 renderFit();
}).catch(()=>{});

fetchProduct('speediance-gym-nano','/api/product/nano').then(product=>{
 const variants=product.variants||[];
 const availableVariants=variants.filter(v=>v.available);
 const variant=availableVariants.length?availableVariants.reduce((a,b)=>Number(a.price)<Number(b.price)?a:b):null;
 if(!variant)return;
 const currency=product.currency||window.Shopify?.currency?.active;if(!currency)return;
 nano={variant,currency,url:origin+rootPath+'products/speediance-gym-nano'};
 const mountNames=availableVariants.map(v=>(v.public_title||v.title||'').trim()).filter(Boolean);
 const captionEl=$('#sh-nano-caption');
 if(captionEl){const mountText=mountNames.length?`${mountNames.join(' or ')} available. `:'';captionEl.textContent=`${mountText}From ${money(Number(variant.price),currency)}.`;}
 const link=$('#sh-nano-link');if(link)link.href=nano.url;
 renderFit();
}).catch(()=>{});

/* Will it fit checker */
const form=$('#sh-fit-form');
const productPaths={'Gym Monster 3, Studio package':'products/speediance-gym-monster-3','Gym Monster Ultra':'products/speediance-gym-monster-ultra','Gym Nano':'products/speediance-gym-nano'};
function recommendation(){
 const space=form.space.value,ceiling=form.ceiling.value,pullups=form.pullups.checked;
 if(space==='rack'){
  return {badge:'Recommended for you',headline:'Gym Nano',body:'A compact cable training option. Check the available mounting package, rack dimensions and compatibility on the regional product page before choosing.',product:nano};
 }
 if(space==='corner'){
  if(pullups){
   return {badge:'Recommended for you',headline:'Gym Monster 3, Studio package',body:'Stores flat in 0.26 m² of that corner. To train, pull it out to 122 × 69 cm (0.84 m²) plus room to move. Pull-ups and lat pulldowns need more room again, around 1.66 × 1.26 m for Gym Monster Ultra, so keep those for a bigger space.',product:gm3Studio};
  }
  return {badge:'Recommended for you',headline:'Gym Monster 3, Studio package',body:'Stores flat in 0.26 m² of that corner. To train, pull it out to 122 × 69 cm (0.84 m²) plus room to move around it. No permanent fixing needed.',product:gm3Studio};
 }
 if(pullups&&ceiling==='high'){
  return {badge:'Recommended for you',headline:'Gym Monster Ultra',body:'Unfolds to 1.66 × 1.26 m (2.08 m² with the lat pulldown arms fitted, 1.41 m² without) and stands 2.27 m tall with the lat pulldown arms fitted, leaving headroom above the bar for pull-ups under a ceiling of 2.6 m or more. Folds flat to 0.59 m² when you are done.',product:ultra};
 }
 if(pullups&&ceiling==='standard'){
  return {badge:'Recommended for you',headline:'Gym Monster Ultra',body:'Unfolds to 1.66 × 1.26 m (2.08 m² with the lat pulldown arms fitted) and fits a standard 2.4 m ceiling for lat pulldowns. Pull-ups need more headroom above the bar, so save those for a taller ceiling. Folds flat to 0.59 m².',product:ultra};
 }
 if(pullups&&ceiling==='low'){
  return {badge:'Recommended for you',headline:'Gym Monster 3, Studio package',body:'Save the pull-up bar for a taller ceiling. Gym Monster 3 opens out to 122 × 69 cm (0.84 m²) and folds to 0.26 m², with no pull-up or lat pulldown clearance needed.',product:gm3Studio};
 }
 return {badge:'Recommended for you',headline:'Gym Monster 3, Studio package',body:'The open platform measures 122 × 69 cm (0.84 m²), with a 0.26 m² folded storage footprint. Allow additional clear space for movement, cables, a bench and accessories.',product:gm3Studio};
}
function renderFit(){
 if(!form)return;
 const r=recommendation();
 $('#sh-fit-badge').textContent=r.badge;
 $('#sh-fit-headline').textContent=r.headline;
 $('#sh-fit-body').textContent=r.body;
 const priceEl=$('#sh-fit-price'),wasEl=$('#sh-fit-price-was'),saveEl=$('#sh-fit-price-save'),buy=$('#sh-fit-buy');
 if(r.product){
  const price=Number(r.product.variant.price),compareAt=Number(r.product.variant.compare_at_price||0),hasSaving=compareAt>price;
  priceEl.textContent=money(price,r.product.currency);
  if(hasSaving){wasEl.textContent=money(compareAt,r.product.currency);wasEl.hidden=false;saveEl.textContent=`Save ${money(compareAt-price,r.product.currency)}`;saveEl.hidden=false;}else{wasEl.hidden=true;saveEl.hidden=true;}
  buy.href=r.product.url;
 }else{
  priceEl.textContent='See current price and availability';wasEl.hidden=true;saveEl.hidden=true;
  buy.href=origin+rootPath+productPaths[r.headline];
 }
 const buyLabel=r.headline==='Gym Nano'?'Meet Gym Nano':r.headline==='Gym Monster Ultra'?'Explore Gym Monster Ultra':'Explore this setup';
 buy.innerHTML=`${buyLabel} <span aria-hidden="true">→</span>`;
}
if(form){form.addEventListener('change',renderFit);renderFit();}

/* Live rating, read from the GM3 product page's own Loox markup */
if(!local){
 const ratingAbort=new AbortController();const ratingTimer=setTimeout(()=>ratingAbort.abort(),8000);
 fetch(`${rootPath}products/speediance-gym-monster-3`,{signal:ratingAbort.signal}).then(r=>{if(!r.ok)throw new Error('unavailable');return r.text();}).then(html=>{
  const ratingMatch=html.match(/data-rating="([\d.]+)"/);
  const ratersMatch=html.match(/data-raters="(\d+)"/);
  if(!ratingMatch||!ratersMatch)return;
  const rating=ratingMatch[1];
  const raters=Math.floor(Number(ratersMatch[1])/100)*100;
  if(!raters)return;
  const ratingEl=$('#sh-rating'),textEl=$('#sh-rating-text');
  if(ratingEl&&textEl){textEl.textContent=`Rated ${rating} by ${raters.toLocaleString('en-AU')}+ Speediance owners`;ratingEl.hidden=false;}
 }).catch(()=>{}).finally(()=>clearTimeout(ratingTimer));
}
})();
